import CryptoJS from "crypto-js";
const aesjs = require("aes-js");
var Buffer = require("buffer/").Buffer;

export function encrypt(keyString, input) {
  const key = keyString.trim();
  const value = input.trim();
  const keyBuffer = aesjs.utils.utf8.toBytes(key);
  const inputBuffer = aesjs.padding.pkcs7.pad(aesjs.utils.utf8.toBytes(value));

  const escEcb = new aesjs.ModeOfOperation.ecb(keyBuffer);
  const encryptedBytes = escEcb.encrypt(inputBuffer);

  const encryptedData = Buffer.from(encryptedBytes).toString("base64");
  return encryptedData;
}

export function decrypt(keyString, input, s) {
  const key = keyString.trim();
  let data;

  if (s) {
    const _s = s.trim();
    data = input.split(_s)[1].trim();
  } else {
    data = input.trim();
  }
  const keyBuffer = aesjs.utils.utf8.toBytes(key);
  const escEcb = new aesjs.ModeOfOperation.ecb(keyBuffer);
  const buf = Buffer.from(data, "base64");
  const decryptedBytes = escEcb.decrypt(buf);
  const decryptedText = aesjs.utils.utf8.fromBytes(decryptedBytes);

  const regex = /[\u{0001}-\u{0010}]/gu;

  const result = regex.test(decryptedText)
    ? decryptedText.replace(/[\u{0001}-\u{0010}]/gu, "")
    : decryptedText;
  return result.trim();
}

function convertDDMMYYYYtoDate(dateString) {
  const [day, month, year] = dateString.split("/");
  return new Date(year, month - 1, day); // Note: month is 0-indexed in JS
}
export function adultAge(dateString) {
  const today = new Date();
  const birthDate = convertDDMMYYYYtoDate(dateString);

  // Check if the date is valid
  if (isNaN(birthDate)) {
    return false;
  }

  // Calculate age
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  if (
    monthDiff < 0 ||
    (monthDiff === 0 && today.getDate() < birthDate.getDate())
  ) {
    age--;
  }

  // Check if age is within range
  return age >= 18 && age <= 120;
}

export function childAge(dateString) {
  const today = new Date();
  const minDate = new Date();
  const maxDate = new Date();
  const birthDate = convertDDMMYYYYtoDate(dateString);

  // Set maximum date (91 days ago)
  maxDate.setDate(today.getDate() - 91);

  // Set minimum date (30 years ago)
  minDate.setFullYear(today.getFullYear() - 30);

  // Check if the birth date is within the allowed range
  if (birthDate >= minDate && birthDate <= maxDate) {
    return true;
  } else {
    return false;
  }
}

export const formatDateDDMMYYYY = (date) => {
  const selectedDate = new Date(date);
  const day = String(selectedDate.getDate()).padStart(2, "0");
  const month = String(selectedDate.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
  const year = selectedDate.getFullYear();

  return `${day}/${month}/${year}`;
};

export function isSafeNonUrl(value) {
  try {
    // If it doesn’t contain a protocol, allow
    return !/^[a-zA-Z][a-zA-Z0-9+.-]*:\/\//.test(value);
  } catch {
    // Invalid URL parsing → treat as safe plain string
    return true;
  }
}
